<template>
  <div id="app">
    <the-navbar></the-navbar>
    <div class="container-fluid">
      <template v-if="dataLoaded">
        <router-view />
      </template>
    </div>
  </div>
</template>

<script>
import TheNavbar from "@/components/TheNavbar/TheNavbar";
import { session } from "@/utilities/session";
import { JSConn } from "@/utilities/js-conn";

export default {
  name: "app",
  components: {
    TheNavbar,
  },
  data() {
    return {
      dataLoaded: false,
    };
  },
  mounted() {
    this.checkSignIn();
  },
  methods: {
    checkSignIn: function() {
      const jsConn = new JSConn();
      jsConn.fromRoutePath = this.$router.currentRoute.path;
      jsConn.toRoutePath = this.$store.getters.nextPath;
      session
        .updateSession(jsConn)
        .then(() => {
          // redirect to the correct place...
          this.$router.push(jsConn.toRoutePath);
          this.dataLoaded = true;
          return Promise.resolve();
        })
        .catch(() => {
          this.$router.push("/log-in");
          this.dataLoaded = true;
        });
    },
  },
};
</script>

<style lang="scss"></style>
